import { baseURL } from "./baseUrl";
import { cachedRequest, requestKey } from "./requestCache";

export const apiGetSingleBrand = async (data: object) => {
  const response = await baseURL.post(`get-all-cms-data`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

// Brand list changes rarely; share one request for every caller.
const BRANDS_TTL_MS = 10 * 60 * 1000;

export const apiGetAllBrands = () =>
  cachedRequest(requestKey("get-all-brands"), BRANDS_TTL_MS, async () => {
    const response = await baseURL.get(`get-all-brands`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  });
